import { Link } from "react-router-dom";

const BornToTradePodcastContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Join the Conversation</h2>
              <p>
                Available across all major streaming platforms, Born to Trade
                connects a global trading community through shared knowledge,
                honest experiences, and proven insights. Because trading success
                starts with learning, and learning never stops. Each episode
                encourages open dialogue, helping traders exchange ideas and
                grow together. Whether you're a beginner seeking clarity or an
                experienced trader looking for fresh perspectives, there's
                always something valuable to take away. Join live discussions,
                submit your questions, and become part of a network that thrives
                on curiosity and continuous improvement. With every
                conversation, you step closer to becoming a more confident and
                informed trader.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Stream Latest Episode
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/born_to_trade_podcast/born_to_trade_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    // </>
  );
};

export default BornToTradePodcastContentThree;
